<!-- Modal Full screen -->
<div bsModal
     #fullImgModal="bs-modal"
     class="modal fade modal-full-screen-img"
     tabindex="-1"
     role="dialog"
     aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">

                <div class="align-items-center active item carousel-item">
                    <a class="left carousel-control carousel-control-prev" role="button"
                       [routerLink]="['..', activePhoto|previousPhotoId:collection]"
                       [state]="{'skipScroll': true}"
                       [replaceUrl]="true" tabindex="0">
                        <span aria-hidden="true" class="icon-prev carousel-control-prev-icon"></span>
                        <span class="sr-only">Previous</span>
                    </a>

                    <div class="full-img-header">
                        <span>{{site.title}}</span>
                        <button type="button"
                                class="close pull-right"
                                aria-label="Close"
                                (click)="fullImgModal.hide()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <img [src]="activePhoto.originalUrl">
                    <div class="full-img-footer">
                        <span class="location">{{activePhoto.lat | number: '.0-7'}}
                            , {{activePhoto.lon | number: '.0-7'}}</span>
                        <span><i class="icon-calendar"></i> {{collection.date | date: 'MM/yyyy'}}</span>
                    </div>

                    <a class="right carousel-control carousel-control-next" role="button"
                       [routerLink]="['..', activePhoto|nextPhotoId:collection]"
                       [state]="{'skipScroll': true}"
                       [replaceUrl]="true" tabindex="0">
                        <span aria-hidden="true" class="icon-next carousel-control-next-icon"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>

            </div>
        </div>
    </div>
</div>
